import router from './router';
const name = '组配置';

export {
  name,
  router,
}
